import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/js/dist/dropdown";
import "../index.css";
import AddVechicle from "./AddVechicle";
import DefaultBoard from "../Dashboard/DefaultBoard";
import { Link, useNavigate } from "react-router-dom";
import AddDriver from "./AddDriver";
import Profile from "./components/Profile";

function DashBoard() {
  const [selectedMenu, setSelectedMenu] = useState("DashBoard");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("clientEmail");
    localStorage.removeItem("userId");
    navigate("/Admin");
  };

  const renderContent = () => {
    switch (selectedMenu) {
      case "Profile":
        return <Profile />;
      case "DashBoard":
        return <DefaultBoard />;
      case "AddVechicle":
        return <AddVechicle />;
      case "AddDriver":
        return <AddDriver />;
      default:
        return <DefaultBoard />;
    }
  };

  return (
    <div className="dashboard-container container-fluid">
      <div className="breadcrumb-link mb-2">
        <Link to="/" className="list-link">
          Home
        </Link>{" "}
        / DashBoard
      </div>

      <div className="row m-0">
        {/* Sidebar Menu */}
        <div className={`sidebar bg-dark col-auto d-flex flex-column min-vh-100 p-0${sidebarOpen ? ' open' : ''}`} style={{ transition: 'width 0.3s', width: sidebarOpen ? 240 : 60 }}>
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="btn toggle-btn rounded-circle mb-3"
            style={{ alignSelf: 'flex-end', margin: '8px' }}
          >
            <span className="toggle-icon">{sidebarOpen ? "«" : "»"}</span>
          </button>
          {sidebarOpen && (
            <div className="sidebar-content">
              <hr className="text-secondary" />
              <ul className="nav nav-pills flex-column mt-3">
                {[
                  { key: "Profile", icon: "bi bi-person-circle", label: "Profile" },
                  { key: "DashBoard", icon: "bi-speedometer2", label: "DashBoard" },
                  { key: "AddVechicle", icon: "bi bi-car-front", label: "AddVechicle" },
                  { key: "AddDriver", icon: "bi bi-person-fill", label: "AddDriver" },
                ].map((item) => (
                  <li
                    key={item.key}
                    className={`nav-item fs-4 my-1 py-2 ${selectedMenu === item.key ? "bg-success text-white" : "text-white"}`}
                    onClick={() => setSelectedMenu(item.key)}
                    style={{ cursor: "pointer" }}
                  >
                    <a href="#" className="nav-link text-white fs-5">
                      <i className={`fs-4 bi ${item.icon}`}></i>
                      {sidebarOpen && <span className="ms-3">{item.label}</span>}
                    </a>
                  </li>
                ))}
                <button onClick={handleLogout} className="logout-btn bg-danger text-white fs-5 border-0 mt-4 p-2">
                  Logout
                </button>
              </ul>
            </div>
          )}
        </div>

        {/* Content Area */}
        <div className="col content-area bg-light p-4">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default DashBoard;
